import { defineComponent as _defineComponent } from 'vue'
import { createElementVNode as _createElementVNode, createTextVNode as _createTextVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, renderList as _renderList, Fragment as _Fragment } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "modal-mask"
}
const _hoisted_2 = { class: "modal-wrapper" }
const _hoisted_3 = { class: "modal-dialog modal-xl modal-dialog-scrollable" }
const _hoisted_4 = { class: "modal-content" }
const _hoisted_5 = { class: "modal-body" }
const _hoisted_6 = { key: 0 }
const _hoisted_7 = { key: 1 }
const _hoisted_8 = { class: "dropdown" }
const _hoisted_9 = {
  class: "btn btn-outline-secondary dropdown-toggle",
  type: "button",
  "data-toggle": "dropdown"
}
const _hoisted_10 = { class: "dropdown-menu" }
const _hoisted_11 = ["onClick"]
const _hoisted_12 = { class: "row" }
const _hoisted_13 = { class: "col-lg-4 col-md-4 col-sm-6 col-xs-12" }
const _hoisted_14 = { class: "card mt-3" }
const _hoisted_15 = { class: "card-header text-center" }
const _hoisted_16 = {
  class: "card-body",
  style: {"max-height":"250px","height":"250px","overflow-y":"auto"}
}
const _hoisted_17 = { class: "card-title" }
const _hoisted_18 = { class: "card-text" }
const _hoisted_19 = ["onClick"]
const _hoisted_20 = { class: "card-footer text-center" }
const _hoisted_21 = ["disabled", "onClick"]

import { computed, ref, toRef } from 'vue'
    import type { PropType } from 'vue'
    import type { CriterionTemplateReadModel } from "@Criteria/Hierarchies/Domain/readmodels"
    import type { DiscreteScale } from '@Scales/Model'
    import type { CriteriaLibraryViewModel } from '@Criteria/Hierarchies/Components/CriteriaLibrary'

    // ---------------- props / emits ----------------

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CriteriaLibrary',
  props: {
        viewModel: {
            type: Object as PropType<CriteriaLibraryViewModel>,
            required: true
        }
    },
  emits: ["create-criterion", "show-scale"],
  setup(__props, { emit: __emit }) {

    const props = __props

    const emit = __emit

    // ---------------- state ----------------

    const vm = toRef(props, 'viewModel')
    const selectedCategory = ref<string | null>(null)

    // ---------------- computed ----------------

    const opened = computed(() => vm.value.isOpen)
    const initialized = computed(() => vm.value.data != null)

    const categories = computed(() => vm.value.data?.CriteriaCategories ?? [])
    const templates = computed(() => vm.value.data?.CriteriaTemplates ?? [])

    const templatesView = computed(() =>
        selectedCategory.value
            ? templates.value.filter(a => a.Category === selectedCategory.value)
            : templates.value
    )

    const categoryLabel = computed(() =>
        selectedCategory.value
            ? `Category: ${selectedCategory.value}`
            : "All templates"
    )

    // ---------------- actions ----------------

    function emitCreateCriterion(rm: CriterionTemplateReadModel)
    {
        emit('create-criterion', vm.value.parentId!, rm.AttributeId, rm.Name)
    }

    function emitShowScale(scale: DiscreteScale)
    {
        emit('show-scale', scale)
    }

    function close()
    {
        vm.value.close()
    }

return (_ctx: any,_cache: any) => {
  return (opened.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createElementVNode("div", { class: "modal-header" }, [
                _cache[1] || (_cache[1] = _createElementVNode("h5", { class: "modal-title" }, "Criteria templates", -1 /* CACHED */)),
                _createElementVNode("button", {
                  type: "button",
                  class: "close",
                  onClick: close
                }, "×")
              ]),
              _createElementVNode("div", _hoisted_5, [
                (!initialized.value)
                  ? (_openBlock(), _createElementBlock("h3", _hoisted_6, [...(_cache[2] || (_cache[2] = [
                      _createElementVNode("i", { class: "fa fa-spinner fa-spin" }, null, -1 /* CACHED */),
                      _createTextVNode(" Loading... ", -1 /* CACHED */)
                    ]))]))
                  : _createCommentVNode("v-if", true),
                (initialized.value)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                      _createElementVNode("div", _hoisted_8, [
                        _createElementVNode("button", _hoisted_9, [
                          _createElementVNode("span", null, _toDisplayString(categoryLabel.value), 1 /* TEXT */)
                        ]),
                        _createElementVNode("div", _hoisted_10, [
                          _createElementVNode("a", {
                            class: "dropdown-item",
                            onClick: _cache[0] || (_cache[0] = ($event: any) => (selectedCategory.value = null))
                          }, "All templates"),
                          _cache[3] || (_cache[3] = _createElementVNode("h6", { class: "dropdown-header" }, "Categories:", -1 /* CACHED */)),
                          (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(categories.value, (c) => {
                            return (_openBlock(), _createElementBlock("a", {
                              class: "dropdown-item",
                              key: c,
                              onClick: ($event: any) => (selectedCategory.value = c)
                            }, _toDisplayString(c), 9 /* TEXT, PROPS */, _hoisted_11))
                          }), 128 /* KEYED_FRAGMENT */))
                        ])
                      ]),
                      _createElementVNode("div", _hoisted_12, [
                        (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(templatesView.value, (item) => {
                          return (_openBlock(), _createElementBlock("div", _hoisted_13, [
                            _createElementVNode("div", _hoisted_14, [
                              _createElementVNode("div", _hoisted_15, [
                                _createElementVNode("span", null, _toDisplayString(item.Category || ' '), 1 /* TEXT */)
                              ]),
                              _createElementVNode("div", _hoisted_16, [
                                _createElementVNode("h5", _hoisted_17, _toDisplayString(item.Name), 1 /* TEXT */),
                                _createElementVNode("p", _hoisted_18, _toDisplayString(item.Description), 1 /* TEXT */),
                                _createElementVNode("a", {
                                  class: "text-primary",
                                  onClick: ($event: any) => (emitShowScale(item.ScaleTemplate)),
                                  title: "View scale template"
                                }, [
                                  _createElementVNode("span", null, "Default scale: " + _toDisplayString(item.ScaleTemplateName), 1 /* TEXT */)
                                ], 8 /* PROPS */, _hoisted_19)
                              ]),
                              _createElementVNode("div", _hoisted_20, [
                                _createElementVNode("button", {
                                  disabled: item.Used,
                                  class: "btn btn-outline-secondary",
                                  onClick: ($event: any) => (emitCreateCriterion(item))
                                }, _toDisplayString(item.Used ? "Added" : "Create"), 9 /* TEXT, PROPS */, _hoisted_21)
                              ])
                            ])
                          ]))
                        }), 256 /* UNKEYED_FRAGMENT */))
                      ])
                    ]))
                  : _createCommentVNode("v-if", true)
              ]),
              _createElementVNode("div", { class: "modal-footer" }, [
                _createElementVNode("button", {
                  onClick: close,
                  type: "button",
                  class: "btn btn-outline-secondary"
                }, "Close")
              ])
            ])
          ])
        ])
      ]))
    : _createCommentVNode("v-if", true)
}
}

})